/*
 * Gallery lightbox.
 *
 * Replaces two pieces of the WordPress theme that had to be ported together: the
 * Bootstrap modal, and the bespoke handler in js/acciones.js that read
 * `data-bs-image` off the clicked tile and assigned it to the modal's <img>.
 *
 * A native <dialog> does the rest — backdrop, focus trap, Escape to close, and
 * returning focus to the trigger — so none of that is reimplemented here.
 */
class LbLightbox extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-lb-lightbox-dialog]');
    this.image = this.querySelector('[data-lb-lightbox-image]');
    if (!this.dialog || !this.image) return;

    this.addEventListener('click', this.onClick);

    // Clicking the backdrop closes: the dialog element itself is the backdrop, so
    // a click landing on it rather than on its contents means outside.
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    // Drop the source on close so a big image is not held in memory, and so the
    // next open never flashes the previous picture.
    this.dialog.addEventListener('close', () => {
      this.image.removeAttribute('src');
      this.image.alt = '';
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const trigger = event.target.closest('[data-lb-lightbox-open]');
    if (!trigger) return;

    this.image.src = trigger.dataset.lbLightboxSrc;
    this.image.alt = trigger.dataset.lbLightboxAlt || '';
    this.dialog.showModal();
  };
}

customElements.define('lb-lightbox', LbLightbox);
